const prefix = 'money-wallet';

export const getUserTransactions = (userId: string) => `${prefix}/admin/transactions/${userId}`;
